"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyCustomValidation = exports.isRequired = exports.defaultParseExtension = void 0;
const index_js_1 = require("../../../errors/index.js");
const formatValuePath_js_1 = require("../../../schema/actions/utils/formatValuePath.js");
const isString_js_1 = require("../../../utils/validation/isString.js");
const defaultParseExtension = (_, input) => ({
    isExtension: false,
    basicInput: input
});
exports.defaultParseExtension = defaultParseExtension;
const isRequired = (attribute, mode) => {
    switch (mode) {
        case 'put':
            return attribute.required !== 'never';
        case 'key':
        case 'update':
            return attribute.required === 'always';
    }
};
exports.isRequired = isRequired;
const applyCustomValidation = (attribute, inputValue, options = {}) => {
    const { mode = 'put', valuePath = [] } = options;
    const customValidator = attribute.validators[attribute.key ? 'key' : mode];
    if (customValidator !== undefined) {
        const validationResult = customValidator(inputValue, attribute);
        if (validationResult !== true) {
            const path = (0, formatValuePath_js_1.formatValuePath)(valuePath);
            throw new index_js_1.DynamoDBToolboxError('parsing.customValidationFailed', {
                message: `Custom validation${path !== undefined ? ` for attribute '${path}'` : ''} failed${(0, isString_js_1.isString)(validationResult) ? ` with message: ${validationResult}` : ''}.`,
                path,
                payload: { received: inputValue, validationResult }
            });
        }
    }
};
exports.applyCustomValidation = applyCustomValidation;
